import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getAccess } from 'utils/hooks/storage/storageGets';

// fixed e.q. PERM.SUPPLIER_SECTION() problem on refresh page
const PermissionProvider = ({ children }) => {
	const { scope } = getAccess();
	const [loadingPermissions, setLoadingPermissions] = useState(scope === 'operator');

	useEffect(() => {
		if(scope === 'operator') {
			const timer = setTimeout(() => {
				setLoadingPermissions(false);
			}, 400);
			return () => clearTimeout(timer);
		}
	}, []);

	if (loadingPermissions) return (
		<div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center">
			<CircularProgress color='secondary' />
		</div>
	);
	return children;
};

export default PermissionProvider;